import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ButtonComponent,
  ButtonIcon,
  ButtonSize,
  ButtonType,
} from '@app/components/button';
import { CardComponent } from '@app/components/card';
import {
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextWeight,
} from '@app/components/text';
import { ViewAlign, ViewComponent } from '@app/components/view';
import { Spacing } from '@app/shared/types';

@Component({
  standalone: true,
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  imports: [
    CommonModule,
    ButtonComponent,
    TextComponent,
    ViewComponent,
    CardComponent,
  ],
})
export class BannerComponent {
  @Input() message!: string;
  @Input() buttonText!: string;
  @Input() buttonIcon = ButtonIcon.NONE;
  @Input() buttonDisabled = false;
  @Input() buttonTitle!: string;
  @Input() testId!: string;
  @Input() spacingBottom = Spacing.MEDIUM;
  @Output() handleButtonClick = new EventEmitter<void>();

  ButtonType = ButtonType;
  ButtonSize = ButtonSize;
  TextColor = TextColor;
  TextWeight = TextWeight;
  TextHeight = TextHeight;
  TextSize = TextSize;
  Spacing = Spacing;
  ViewAlign = ViewAlign;

  onButtonClick() {
    this.handleButtonClick.emit();
  }
}
